import React, { Dispatch, SetStateAction, useEffect } from 'react'
import Branch from './branch'
import styles from './treeView.module.scss'
import { useState } from 'react'
import { getFolderStructure } from '../../utils/folderStructure'
var _ = require('lodash');

export default function TreeView({
    modules,
    setReadme,
}: {
    modules: ModuleObject[]
    setReadme: Dispatch<SetStateAction<ModuleObject | undefined>>
}) {
    const [searchInput, setSearchInput] = useState('')
    const [folders, setFolders] = useState<FolderObject>();
    useEffect(()=> {
        setFolders(getFolderStructure(modules));
    },[modules])

    let filteredFolders:FolderObject = folders? _.cloneDeep(folders):null;
    if(searchInput !== '' && filteredFolders) {
        removeFolders(filteredFolders);
    }

    return (
        <div className={styles.treeView}>
            <input
                type="search"
                className={styles.moduleSearch}
                value={searchInput}
                onChange={(e) => setSearchInput(e.target.value)}
            />
            {filteredFolders && filteredFolders.children.map((branch, key) => (
                <Branch branch={branch} setReadme={setReadme} key={key} />
            ))}
        </div>
    )

    function removeFolders(folders:FolderObject):void {
        for(let i = folders.children.length-1; i>=0; i--) {
            if(!folders.children[i].includes || folders.children[0].includes.size===0) return;
            const searchInputFound = [...folders.children[i].includes].filter(moduleName=> moduleName.includes(searchInput))
            if(searchInputFound.length>0) {
                removeFolders(folders.children[i])
            } else {
                folders.children.splice(i,1);
            }
        }
    }
}


